import Vue from 'vue';
import ColorizeImageSlider from '../../qaamgo/modules/sat/components/ColorizeImageSlider.vue';

// Import the library
import 'img-comparison-slider';

const firstImageWO = document.querySelector('.ai-remove-background-wrapper').dataset.firstImageWo;
const secondImageWO = document.querySelector('.ai-remove-background-wrapper').dataset.secondImageWo;

const firstImageVC = document.querySelector('.ai-remove-background-wrapper').dataset.firstImageVc;
const secondImageVC = document.querySelector('.ai-remove-background-wrapper').dataset.secondImageVc;

const firstImagePB = document.querySelector('.ai-remove-background-wrapper').dataset.firstImagePb;
const secondImagePB = document.querySelector('.ai-remove-background-wrapper').dataset.secondImagePb;

new Vue({
    el: '#aiRemoveBackgroundWoman',
    name: 'AiRemoveBackgroundWoman',
    components: {
        ColorizeImageSlider,
    },
    render(h) {
        return h(ColorizeImageSlider, {
            props: {
                firstImage: firstImageWO,
                secondImage: secondImageWO,
            },
        });
    },
});

new Vue({
    el: '#aiRemoveBackgroundCar',
    name: 'AiRemoveBackgroundCar',
    components: {
        ColorizeImageSlider,
    },
    render(h) {
        return h(ColorizeImageSlider, {
            props: {
                firstImage: firstImageVC,
                secondImage: secondImageVC,
            },
        });
    },
});

new Vue({
    el: '#aiRemoveBackgroundBottle',
    name: 'AiRemoveBackgroundBottle',
    components: {
        ColorizeImageSlider,
    },
    render(h) {
        return h(ColorizeImageSlider, {
            props: {
                firstImage: firstImagePB,
                secondImage: secondImagePB,
            },
        });
    },
});
